import { Heading, Stepper } from "@/components";
import useAddEditVendor from "./useAddEditVendor";
import { cn } from "@/lib/utils";
import { steps } from "./consts";
import { Step1, Step2 } from "./components";

const AddEditVendor = () => {
  const {
    breadcrumbData,
    isView,
    onBackClick,
    isMobile,
    onNextStepClick,
    onPreviousStepClick,
    onStepperClick,
    currentStep,
  } = useAddEditVendor();

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <Heading
          title={isView ? "View Vendor" : "Vendor Management"}
          showBack
          onBackClick={onBackClick}
          breadcrumbData={breadcrumbData}
        />
        <div className={cn(isMobile ? "pt-4" : "pt-6 px-6")}>
          <Stepper
            steps={steps}
            currentStep={currentStep}
            onStepperClick={onStepperClick}
          />
        </div>
      </div>

      {currentStep == 1 ? (
        <Step1
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          onPreviousClick={onPreviousStepClick}
        />
      ) : currentStep == 2 ? (
        <Step2
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          onPreviousClick={onPreviousStepClick}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default AddEditVendor;
